import React from 'react';

import { Badge } from '../Badge/Badge';
import css from './BadgeStrip.module.css';

/**
 * @param {object[]} enrichments  badges to render: `{ type, display, priority }[]`
 * @param {string} [className]    optional wrapper override. Defaults to the
 *   absolutely-positioned card overlay (`.badgeStrip`). Pass a host class to
 *   render the strip inline (e.g. on a listing detail page).
 */
export const BadgeStrip = ({ enrichments, className }) => {
  if (!enrichments || enrichments.length === 0) {
    return null;
  }

  const sortedBadges = [...enrichments].sort((a, b) => {
    const aPriority = typeof a.priority === 'number' ? a.priority : Number.MAX_SAFE_INTEGER;
    const bPriority = typeof b.priority === 'number' ? b.priority : Number.MAX_SAFE_INTEGER;
    return aPriority - bPriority;
  });

  return (
    <div className={className || css.badgeStrip}>
      {sortedBadges.map((badge, index) => (
        <Badge key={`${badge.type || 'badge'}-${index}`} badge={badge} />
      ))}
    </div>
  );
};
